import Navigation from '@App/navigation'
import { AttachedOverclaimMemberUpload } from '@Entities/overclaim/overclaim-document-search-result'
import React, { Fragment } from 'react'
import { Link } from 'react-router'

interface LinkedOverclaimUploadsProps {
    linkedOverclaimUploads: AttachedOverclaimMemberUpload[]
    rightsholderId: number
}

const LinkedOverclaimUploads = ({ linkedOverclaimUploads, rightsholderId }: LinkedOverclaimUploadsProps) => {
    if (!linkedOverclaimUploads.length) {
        return <>-</>
    }

    return linkedOverclaimUploads.map((linkedOverclaimUpload, index) => (
        <Fragment key={linkedOverclaimUpload.overclaimMemberUploadId}>
            <Link
                to={Navigation.rightholder.overclaim.view(rightsholderId, linkedOverclaimUpload.overclaimHeaderId)}
                target="_blank"
                rel="noreferrer"
            >
                {linkedOverclaimUpload.overclaimHeaderId}
            </Link>
            {index < linkedOverclaimUploads.length - 1 ? ', ' : ''}
        </Fragment>
    ))
}

export default LinkedOverclaimUploads
